import React, { useState } from "react";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  InputAdornment,
  IconButton,
  MenuItem,
  Select,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import useStyles from "../../themes/style.js";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import CloseIcon from "@material-ui/icons/Close";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { jwtDecode } from "jwt-decode";
import { HiQuestionMarkCircle } from "react-icons/hi2";
import { Controller } from "react-hook-form";

const InformationTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#c8d8f8",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 250,
    fontFamily: "'Inter', sansSerif",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #7da5f6",
  },
  arrow: {
    color: "#7da5f6",
  },
}))(Tooltip);

function AddUser(props) {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);

  const [values, setValues] = useState({
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  return (
    <Box sx={{ width: "100%" }} role="presentation">
      <List>
        <Card className={classes.root}>
          <CardHeader>
            <Grid
              container
              direction="row"
              spacing={1}
              className={classes.drawerHeader}
            >
              <Grid item xs={10} md={6}>
                <Typography variant="subtitle1"> Add User </Typography>
              </Grid>

              <Grid item xs={2} lg={6} className={classes.drawerClose}>
                <CloseIcon
                  className={classes.closeBtn}
                  size="14px"
                  onClick={props.toggleDrawer("right", false)}
                />
              </Grid>
            </Grid>
          </CardHeader>
          <form
            onSubmit={props.handleSubmit(props.handleAdd,(e)=>console.log(e))}
            autoComplete="off"
            noValidate
          >
            <CardContent className={classes.scrollCard}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormControl className={classes.margin}>
                    <InputLabel shrink htmlFor="roleName">
                      Select User Category
                    </InputLabel>

                    <Select
                      label="Role"
                      name="roleName"
                      defaultValue={""}
                      classes={{
                        root: classes.customSelectField,
                        icon: classes.customSelectIcon,
                      }}
                      onChange={(e) => {
                        props.setValue("roleName", e.target.value); // Update the form state
                        props.setUserRoleName(e.target.value);
                      }}
                      error={props.errors.roleName ? true : false}
                      disableUnderline
                    >
                      {[
                        <MenuItem value="">Select option</MenuItem>,
                        <MenuItem key="subvendor" value="SUBVENDOR">
                          {decode.companyType === "COMPANY"
                            ? "Freelancer"
                            : "Sub Vendor"}{" "}
                        </MenuItem>,
                        <MenuItem key="subcontract" value="SUBCONTRACT">
                          Vendor{" "}
                        </MenuItem>,
                        
                        decode.companyType === "COMPANY" ? null : (
                          <MenuItem key="freelancer" value="FREELANCER">
                            Freelancer{" "}
                          </MenuItem>,
                          <MenuItem key="recruiter" value="RECRUITER">
                          Recruiter
                        </MenuItem>,
                        <MenuItem
                          key="clientCoordinator"
                          value="CLIENTCOORDINATOR"
                        >
                          {decode.companyType === "COMPANY"
                            ? "Hiring Manager"
                            : "Client Coordinator"}{" "}
                        </MenuItem>,
                        <MenuItem key="employee" value="EMPLOYEE">
                          Employee
                        </MenuItem>
                        ),
                      ]}
                    </Select>

                    <Typography variant="inherit" color="error">
                      {props.errors.roleName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                {(props.userRoleName === "SUBVENDOR" ||
                  props.userRoleName === "SUBCONTRACT") && (
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="companyName">
                      Company Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Company Name"
                        id="companyName"
                        name="companyName"
                        {...props.register("companyName")}
                        error={props.errors.companyName ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {props.errors.companyName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="firstName">
                    First Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter First Name"
                      id="firstName"
                      name="firstName"
                      {...props.register("firstName")}
                      error={props.errors.firstName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {props.errors.firstName?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="lastName">
                    Last Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Last Name"
                      id="lastName"
                      name="lastName"
                      {...props.register("lastName")}
                      error={props.errors.lastName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {props.errors.lastName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="email">
                    Email
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Email"
                      id="email"
                      name="email"
                      {...props.register("email")}
                      error={props.errors.email ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {props.errors.email?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="password">
                    Password
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      type={values.showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      id="password"
                      InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                            >
                              {values.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...props.register("password")}
                      error={props.errors.password ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {props.errors.password?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="mobile">
                    Mobile
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      type="number"
                      placeholder="Enter Mobile Number"
                      id="mobile"
                      name="mobile"
                      {...props.register("mobile")}
                      error={props.errors.mobile ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {props.errors.mobile?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                {props.userRoleName !== "SUBCONTRACT" && (
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <InputLabel shrink htmlFor="employeeId">
                      Employee ID
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        type="number"
                        placeholder="Enter Employee Id"
                        id="employeeId"
                        name="employeeId"
                        {...props.register("employeeId")}
                        error={props.errors.employeeId ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {props.errors.employeeId?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                )}
                {props.userRoleName === "SUBVENDOR" ||
                props.userRoleName === "SUBCONTRACT" ? (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="companyAddress">
                        Company Address
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Company Address"
                          id="companyAddress"
                          name="companyAddress"
                          {...props.register("companyAddress")}
                          error={props.errors.companyAddress ? true : false}
                        />
                        <Typography variant="inherit" color="error">
                          {props.errors.companyAddress?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="headOfficeLocation">
                        Head Office Location
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Head Office Location"
                          id="headOfficeLocation"
                          name="headOfficeLocation"
                          {...props.register("headOfficeLocation")}
                          error={props.errors.headOfficeLocation ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {props.errors.headOfficeLocation?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="branchOfficeLocation">
                        Branch Office Location
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Branch Office Location"
                          id="branchOfficeLocation"
                          name="branchOfficeLocation"
                          {...props.register("branchOfficeLocation")}
                          error={
                            props.errors.branchOfficeLocation ? true : false
                          }
                        />

                        <Typography variant="inherit" color="error">
                          {props.errors.branchOfficeLocation?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="capabilities">
                        Hiring Support
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="IT/Non-IT/NICHE/SUPER NICHE/Leadership"
                          id="capabilities"
                          name="capabilities"
                          {...props.register("capabilities")}
                          error={props.errors.capabilities ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {props.errors.capabilities?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="recruiterCapacity">
                        Recruiter Capacity
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Recruiter Capacity"
                          id="recruiterCapacity"
                          name="recruiterCapacity"
                          {...props.register("recruiterCapacity")}
                          error={props.errors.recruiterCapacity ? true : false}
                        />
                        <Typography variant="inherit" color="error">
                          {props.errors.recruiterCapacity?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </>
                ) : (
                  <></>
                )}

                {props.userRoleName === "SUBVENDOR" && (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="totalExp">
                        Total Experiance as a Recruiter
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Total Experiance as a Recruiter"
                          id="totalExp"
                          name="totalExp"
                          {...props.register("totalExp")}
                          error={props.errors.totalExp ? true : false}
                        />
                        <Typography variant="inherit" color="error">
                          {props.errors.totalExp?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="currentLocation">
                        Current Location
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Current Location"
                          id="currentLocation"
                          name="currentLocation"
                          {...props.register("currentLocation")}
                          error={props.errors.currentLocation ? true : false}
                        />
                        <Typography variant="inherit" color="error">
                          {props.errors.currentLocation?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="willingToWork">
                        No of Days willing to work in a Weak
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter No of Days willing to work in a Weak"
                          id="willingToWork"
                          name="willingToWork"
                          {...props.register("willingToWork")}
                          error={props.errors.willingToWork ? true : false}
                        />
                        <Typography variant="inherit" color="error">
                          {props.errors.willingToWork?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="hoursToWork">
                        How many hours do you work in a day
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Recruiter Capacity"
                          id="hoursToWork"
                          name="hoursToWork"
                          {...props.register("hoursToWork")}
                          error={props.errors.hoursToWork ? true : false}
                        />
                        <Typography variant="inherit" color="error">
                          {props.errors.hoursToWork?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </>
                )}

                {props.userRoleName === "SUBCONTRACT" && (
                  <>
                    <Grid item xs={12} sm={6} lg={6}>
                      <InputLabel
                        shrink
                        htmlFor="minimumCommercialFee"
                        className="overLengthText"
                      >
                        <span>
                          Mention your Minimum Commercial Fee per Permanent
                          Placement Candidate %
                        </span>

                        <InformationTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                style={{ fontSize: "12px" }}
                              >
                                Mention your Minimum Commercial Fee per
                                Permanent Placement Candidate %
                              </Typography>
                            </React.Fragment>
                          }
                          placement="bottom"
                          aria-label="title"
                        >
                          <div className={classes.infoTooltipIcon}>
                            <HiQuestionMarkCircle
                              style={{ color: "#3f3ffe" }}
                            />
                          </div>
                        </InformationTooltip>
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <Select
                          defaultValue={
                            props.vendorDetails.minimumCommercialFee
                          }
                          name="minimumCommercialFee"
                          {...props.register("minimumCommercialFee", {
                            onChange: (e) => {
                              props.handleSourceProfileCheck(e);
                            },
                          })}
                          error={
                            props.errors.minimumCommercialFee ? true : false
                          }
                          classes={{
                            root: classes.customSelectField,
                            icon: classes.customSelectIcon,
                          }}
                          disableUnderline
                        >
                          <MenuItem value="">Select option</MenuItem>
                          {(() => {
                            const options = [];
                            for (let i = 1; i <= 99; i++) {
                              options.push(`${i}%`);
                              if (i === 7) options.push("7.5%");
                              if (i === 8) options.push("8.33%");
                            }

                            return options.map((value) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ));
                          })()}
                        </Select>

                        <Typography variant="inherit" color="error">
                          {props.errors.minimumCommercialFee?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                      <InputLabel shrink htmlFor="contractStaffing">
                        Do you also do Contract Staffing
                      </InputLabel>
                      <Select
                        name="contractStaffing"
                        defaultValue={props.vendorDetails.contractStaffing}
                        {...props.register("contractStaffing", {
                          onChange: (e) => {
                            props.handleVendorDetailsChange(e);
                          },
                        })}
                        error={props.errors.contractStaffing ? true : false}
                        classes={{
                          root: classes.customSelectField,
                          icon: classes.customSelectIcon,
                        }}
                        disableUnderline
                      >
                        <MenuItem value="">Select option</MenuItem>
                        <MenuItem value="Yes"> Yes </MenuItem>
                        <MenuItem value="No">No </MenuItem>
                      </Select>
                      <Typography variant="inherit" color="error">
                        {props.errors.contractStaffing?.message}
                      </Typography>
                    </Grid>

                    {props.vendorDetails.contractStaffing === "Yes" ? (
                      <Grid item xs={12} sm={6} lg={6}>
                        <InputLabel
                          shrink
                          htmlFor="minimumMarkup"
                          className="overLengthText"
                        >
                          <span>
                            Mention your Minimum Commercial Markup % or Flat fee
                            per Contract Candidate (Margin Amount)
                          </span>
                          <InformationTooltip
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  style={{ fontSize: "12px" }}
                                >
                                  Mention your Minimum Commercial Markup % or
                                  Flat fee per Contract Candidate (Margin
                                  Amount)
                                </Typography>
                              </React.Fragment>
                            }
                            placement="bottom"
                            aria-label="title"
                          >
                            <div className={classes.infoTooltipIcon}>
                              <HiQuestionMarkCircle
                                style={{ color: "#3f3ffe" }}
                              />
                            </div>
                          </InformationTooltip>
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            required={"true"}
                            classes={{ root: classes.customTextField }}
                            InputProps={{ disableUnderline: true }}
                            size="small"
                            placeholder="Mention your Minimum Commercial Markup % or Flat fee per Contract Candidate (Margin Amount)"
                            id="minimumMarkup"
                            name="minimumMarkup"
                            {...props.register("minimumMarkup")}
                            error={props.errors.minimumMarkup ? true : false}
                          />
                        </FormControl>
                      </Grid>
                    ) : (
                      ""
                    )}

                    <Grid item xs={12} sm={6} lg={6}>
                      <InputLabel shrink htmlFor="source">
                        From where will you Source Profile
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={props.vendorDetails.JobPortal}
                                onChange={props.handleSourceProfileCheck}
                                name="JobPortal"
                              />
                            }
                            label="Job Portal"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={props.vendorDetails.SocialMedia}
                                onChange={props.handleSourceProfileCheck}
                                name="SocialMedia"
                              />
                            }
                            label="Social Media"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={props.vendorDetails.Reference}
                                onChange={props.handleSourceProfileCheck}
                                name="Reference"
                              />
                            }
                            label="Reference"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={props.vendorDetails.OthersMention}
                                onChange={props.handleSourceProfileCheck}
                                name="OthersMention"
                              />
                            }
                            label="Others Mention"
                          />
                        </FormGroup>

                        {props.vendorDetails.OthersMention === true ? (
                          <TextField
                            required="true"
                            classes={{ root: classes.customTextField }}
                            InputProps={{ disableUnderline: true }}
                            size="small"
                            placeholder="Others Mention"
                            id="OthersMentionValue"
                            name="OthersMentionValue"
                            onChange={(e) => {
                              props.handleVendorDetailsChange(e);
                            }}
                          />
                        ) : (
                          ""
                        )}

                        <Typography variant="inherit" color="error">
                          {props.errors.sourceProfileFrom?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                      <InputLabel
                        shrink
                        htmlFor="aboutATS"
                        className="overLengthText"
                      >
                        <span>
                          Are you using an ATS (Applicant Tracking System)
                          already? (If Yes)
                        </span>
                        <InformationTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                style={{ fontSize: "12px" }}
                              >
                                Are you using an ATS (Applicant Tracking System)
                                already? (If Yes)
                              </Typography>
                            </React.Fragment>
                          }
                          placement="bottom"
                          aria-label="title"
                        >
                          <div className={classes.infoTooltipIcon}>
                            <HiQuestionMarkCircle
                              style={{ color: "#3f3ffe" }}
                            />
                          </div>
                        </InformationTooltip>
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          size="small"
                          placeholder="Mention ATS Details"
                          id="aboutATS"
                          name="aboutATS"
                          {...props.register("aboutATS")}
                          error={props.errors.aboutATS ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {props.errors.aboutATS?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                      <InputLabel shrink htmlFor="GSTNumber">
                        Your Company GST Number (Optional)
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          size="small"
                          placeholder="Enter Your Company GST Number"
                          id="GSTNumber"
                          name="GSTNumber"
                          {...props.register("GSTNumber")}
                          error={props.errors.GSTNumber ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {props.errors.GSTNumber?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </>
                )}

              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.clientDrawerFooter}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={props.isSubmitting}
                  type="submit"
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={props.toggleDrawer("right", false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </form>
        </Card>
      </List>
    </Box>
  );
}

export default AddUser;
